var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.dataArray),function(i,index){return _c('el-tab-pane',{key:_vm.keyName + index,attrs:{"label":i.label,"name":i.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }